export default "__VITE_ASSET__DGclHzqB__"